/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GeneralCargoOrderDto } from '../model';
/**
 * GeneralCargoOrdersApi - axios parameter creator
 */
export const GeneralCargoOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoOrdersGetByOrderId: async (orderId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoOrders/GetByOrderId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralCargoOrdersApi - functional programming interface
 */
export const GeneralCargoOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralCargoOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoOrdersGetByOrderId(orderId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoOrdersGetByOrderId(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoOrdersApi.generalCargoOrdersGetByOrderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralCargoOrdersApi - factory interface
 */
export const GeneralCargoOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralCargoOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralCargoOrdersApiGeneralCargoOrdersGetByOrderIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoOrdersGetByOrderId(requestParameters: GeneralCargoOrdersApiGeneralCargoOrdersGetByOrderIdRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoOrderDto> {
            return localVarFp.generalCargoOrdersGetByOrderId(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for generalCargoOrdersGetByOrderId operation in GeneralCargoOrdersApi.
 */
export interface GeneralCargoOrdersApiGeneralCargoOrdersGetByOrderIdRequest {
    readonly orderId?: number
}

/**
 * GeneralCargoOrdersApi - object-oriented interface
 */
export class GeneralCargoOrdersApi extends BaseAPI {
    /**
     * 
     * @param {GeneralCargoOrdersApiGeneralCargoOrdersGetByOrderIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoOrdersGetByOrderId(requestParameters: GeneralCargoOrdersApiGeneralCargoOrdersGetByOrderIdRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoOrdersApiFp(this.configuration).generalCargoOrdersGetByOrderId(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
}

